/* eslint-disable */
/*  export const baseURL =  'http://quiz.myserendipityjourney.com ';
 export const cmsURL =  'http://www.myserendipityjourney.com';
*/ 

export const baseURL =  'http://quiz.dip.com.sg';
 export const cmsURL =  'http://dev.dip.com.sg/masj';


// WEBPACK FOOTER //
// ./src/config.js